import { useMutation } from '@tanstack/react-query'

import { FinanceService } from '../lib/finance.service'
import { BalancePayDTO } from '../lib/finance.types'

export const useBalancesPay = () => {
  return useMutation({
    mutationFn: (params: BalancePayDTO) => {
      return FinanceService.makePayment(params)
    }
  })
}
